"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIAbstractDropdown = _interopRequireDefault(require("../dropdown/abstract/UIAbstractDropdown"));

var _UITypeahead = _interopRequireDefault(require("../typeahead/UITypeahead"));

var _UIGroupedTypeahead = _interopRequireDefault(require("../typeahead/UIGroupedTypeahead"));

var _PlacementConstants = require("../tooltip/PlacementConstants");

var _ButtonConstants = require("../button/ButtonConstants");

var _InputConstants = require("./InputConstants");

var _SelectOptionUtils = require("./utils/SelectOptionUtils");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _FieldsetContext = require("../context/FieldsetContext");

var UISearchableSelectInput = _react.default.createClass({
  displayName: "UISearchableSelectInput",
  propTypes: {
    autoFocus: _react.PropTypes.bool,
    buttonUse: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired,
    children: _react.PropTypes.node,
    disabled: _UIAbstractDropdown.default.propTypes.disabled,
    dropdownClassName: _react.PropTypes.string,
    error: _react.PropTypes.bool,
    inputRef: _refObject.default.isRequired,
    itemComponent: _component.default,
    layout: _react.PropTypes.oneOf(['list', 'grouped']),
    menuWidth: _UIAbstractDropdown.default.propTypes.menuWidth,
    minimumSearchCount: _react.PropTypes.number,
    onChange: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onSearchChange: _react.PropTypes.func,
    open: _UIAbstractDropdown.default.propTypes.open,
    options: _UITypeahead.default.propTypes.options,
    placeholder: _react.PropTypes.node,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
    typeaheadPlaceholder: (0, _createLazyPropType.default)(_react.PropTypes.string).isRequired,
    value: _UITypeahead.default.propTypes.value
  },
  getDefaultProps: function getDefaultProps() {
    return {
      buttonUse: 'form',
      itemComponent: 'li',
      layout: 'list',
      minimumSearchCount: 8,
      open: false,
      placement: 'bottom',
      typeaheadPlaceholder: function typeaheadPlaceholder() {
        return _I18n.default.text('salesUI.UISearchableSelectInput.placeholder');
      },
      value: ''
    };
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        inputRef = _this$props.inputRef,
        open = _this$props.open;

    if (!prevProps.open && open) {
      if (inputRef.current) inputRef.current.focus();
    } // Reposition the Tether, as the results list may have changed height.


    if (this._dropdownRef) {
      this._dropdownRef.reposition();
    }
  },
  focus: function focus() {
    this.setIsOpen(true);
  },
  handleFocusLeave: function handleFocusLeave() {// Temporarily disabled. This causes close-and-reopen when clicking the anchor.
    // this.setIsOpen(false);
  },
  handleSearchChange: function handleSearchChange(evt) {
    var onSearchChange = this.props.onSearchChange;
    (0, _Functions.callIfPossible)(onSearchChange, evt); // We reposition the Tether after the new search results flush to the DOM,
    // by way of componentDidUpdate().

    this.forceUpdate();
  },
  handleSelect: function handleSelect(evt) {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        value = _this$props2.value;

    if (evt.target.value !== value) {
      onChange(evt);
    }

    this.setIsOpen(false);
  },
  setIsOpen: function setIsOpen(nextOpen) {
    var onOpenChange = this.props.onOpenChange;
    onOpenChange((0, _SyntheticEvent.default)(nextOpen));
  },
  dropdownRefCallback: function dropdownRefCallback(ref) {
    this._dropdownRef = ref;
  },
  render: function render() {
    var _this = this;

    var _this$props3 = this.props,
        autoFocus = _this$props3.autoFocus,
        children = _this$props3.children,
        className = _this$props3.className,
        dropdownClassName = _this$props3.dropdownClassName,
        error = _this$props3.error,
        inputRef = _this$props3.inputRef,
        itemComponent = _this$props3.itemComponent,
        layout = _this$props3.layout,
        minimumSearchCount = _this$props3.minimumSearchCount,
        onBlur = _this$props3.onBlur,
        options = _this$props3.options,
        placeholder = _this$props3.placeholder,
        typeaheadPlaceholder = _this$props3.typeaheadPlaceholder,
        value = _this$props3.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props3, ["autoFocus", "children", "className", "dropdownClassName", "error", "inputRef", "itemComponent", "layout", "minimumSearchCount", "onBlur", "options", "placeholder", "typeaheadPlaceholder", "value"]);
    var Typeahead = layout === 'grouped' ? _UIGroupedTypeahead.default : _UITypeahead.default;
    var computedValue = value == null ? '' : value;

    var _getButtonProps = (0, _SelectOptionUtils.getButtonProps)({
      options: options,
      placeholder: placeholder,
      resetValue: '',
      value: computedValue
    }),
        buttonText = _getButtonProps.buttonText,
        valueIsValid = _getButtonProps.valueIsValid;

    var computedDropdownClassName = (0, _classNames.default)('private-searchable-select-input__dropdown', dropdownClassName);
    return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref) {
      var fieldSize = _ref.size;
      return _react.default.createElement(_UIAbstractDropdown.default, (0, _extends2.default)({}, rest, {
        "aria-invalid": !valueIsValid,
        autoFocus: autoFocus,
        buttonText: buttonText,
        className: (0, _classNames.default)(className, _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], {
          noValue: computedValue === '',
          invalid: !valueIsValid,
          'private-form__control--error': error
        }),
        dropdownClassName: computedDropdownClassName,
        onFocusLeave: _this.handleFocusLeave,
        pinToConstraint: ['top', 'bottom'],
        ref: _this.dropdownRefCallback
      }), children, _react.default.createElement(Typeahead, {
        inputRef: inputRef,
        itemComponent: itemComponent,
        minimumSearchCount: minimumSearchCount,
        onBlur: onBlur,
        onChange: _this.handleSelect,
        onSearchChange: _this.handleSearchChange,
        options: options,
        placeholder: (0, _lazyEval.default)(typeaheadPlaceholder),
        value: value
      }));
    });
  }
});

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UISearchableSelectInput, ['open', 'value']));

exports.default = _default;
module.exports = exports.default;